export default import.meta.ROLLDOWN_FILE_URL_49HLEVozYLwea3croYnksw